import { VList } from 'virtua';
// mantine
import { Radio } from '@mantine/core';
// utils
import type { IPossibleValue } from '@newo/api/gateway';
// assets
import styles from '@/modules/Integrations/components/Selection/components/AsyncList/AsyncList.module.css';

interface AsyncListProps {
    items: IPossibleValue[];
    onRangeChange: (start: number, end: number) => void;
}

const AsyncList = ({ items, onRangeChange }: AsyncListProps) => {
    return (
        <div>
            <VList className={styles.list} onRangeChange={onRangeChange}>
                {items.map((item) => (
                    <div className={styles.row} key={item.value}>
                        <Radio label={item.display_value} value={item.value} />
                    </div>
                ))}
            </VList>
        </div>
    );
};

export default AsyncList;
